// src/components/Dashboard/FilterBarArticulos.js
import React from 'react';
import './FilterBar.css'; // Reutilizamos el mismo CSS

const FilterBarArticulos = ({ filters, setFilters, onApply, isLoading }) => {

  const handleChange = (e) => {
    const { name, value } = e.target;
    setFilters(prevFilters => ({
      ...prevFilters,
      [name]: value
    }));
  };

  return (
    <div className="filter-bar card shadow-sm mb-4">
      <div className="card-body">
        <div className="row g-3 align-items-end">

          {/* --- Filtro de Rango de Fechas (Igual) --- */}
          <div className="col-md-4">
            <label htmlFor="dateRange" className="form-label">Rango de Fechas</label>
            <select
              id="dateRange"
              name="dateRange"
              className="form-select"
              value={filters.dateRange}
              onChange={handleChange}
              disabled={isLoading}
            >
              <option value="30d">Últimos 30 días</option>
              <option value="90d">Últimos 90 días</option>
              <option value="mesActual">Este Mes</option>
            </select>
          </div>

          {/* --- Filtro de Artículo (código o descripción) --- */}
          <div className="col-md-5">
            <label htmlFor="articulo" className="form-label">Artículo</label>
            <input
              type="text"
              id="articulo"
              name="articulo"
              className="form-control"
              placeholder="Buscar por código o descripción..."
              value={filters.articulo}
              onChange={handleChange}
              disabled={isLoading}
            />
          </div>

          {/* --- Botón de Aplicar (Igual) --- */}
          <div className="col-md-3">
            <button 
              className="btn btn-primary w-100" 
              onClick={onApply} 
              disabled={isLoading}
            >
              {isLoading ? (
                <span className="spinner-border spinner-border-sm" role="status" aria-hidden="true"></span>
              ) : (
                <><i className="bi bi-funnel-fill me-2"></i> Aplicar Filtros</>
              )}
            </button>
          </div>
        </div>
      </div>
    </div>
  );
};

export default FilterBarArticulos;